import React from 'react'
import DefaultLayout from '../../layouts/Default'
import Hero from '../../components/Hero'
import CaseStudy from '../../components/CaseStudy'
import TropicanaImg from '../../assets/images/tropicana-beauty.png'
import WalmartImg from '../../assets/images/walmart-beauty.png'
import PublixImg from '../../assets/images/publix-beauty.png'
import PublixMeatTraceImg from '../../assets/images/publix-meat-trace-beauty.png'
import CompaniesLogoImg from '../../assets/images/companies-logo.png'

const Work = () => {
  return (
    <DefaultLayout pageTitle="work" home>
      <Hero
        bottomImage={CompaniesLogoImg}
        bottomImageAlt="Logos of companies Drew has worked with"
      />
      <div className="work-case-studies">
        <CaseStudy
          className="publix coming-soon"
          title="meat trace app"
          company="publix"
          image={PublixMeatTraceImg}
          comingSoon
          comingSoonLabel="Coming in May"
          story="Streamlines daily meat intake and simplifies grinder management for faster, more efficient workflows."
        />
        <CaseStudy
          className="publix"
          title="deli order experience"
          company="publix"
          image={PublixImg}
          link="work/publix"
          story="A new way for Publix deli employees to manage orders — now being tested in stores across Florida."
        />
        <CaseStudy
          className="tropicana"
          title="Truck Delivery App"
          company="tropicana"
          image={TropicanaImg}
          link="work/tropicana"
          story="Now used nationwide, I uncovered costly business problems and proposed a new solution that resulted in saving 225k/year and increased driver income."
        />
        <CaseStudy
          className="walmart"
          title="out of stock recapture"
          company="walmart"
          image={WalmartImg}
          link="work/walmart"
          locked
          story="Recaptured customers shopping for backordered items by implementing a new customer notification experience."
        />

    </div>
    </DefaultLayout>
  )
}

export default Work;
